export default __webpack_public_path__ + "static/media/calendar-icon.9a50d4ec.png";